import { LuCalendarRange } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { AiOutlineUser } from "react-icons/ai";

const sidebarMenu = [
	{
		id: 1,
		path: "/dashboard/event-list",
		name: "Event List",
		icon: <LuCalendarRange />,
		indicator: <GoDotFill />,
	},
	{
		id: 2,
		path: "/dashboard/profile",
		name: "Profile",
		icon: <AiOutlineUser />,
		indicator: <GoDotFill />,
	},
];

export default sidebarMenu;
